let url = "";
if (window) {
  url = window.location.href;
}

let env = "development";

let environment = process.env.NODE_ENV ? process.env.NODE_ENV : env;

if (url.indexOf("qa") != -1) {
  environment = "testing";
}

if (url.indexOf("dev") != -1) {
  environment = "development";
}

environment = process.env.REACT_APP_NODE_ENV
  ? process.env.REACT_APP_NODE_ENV
  : environment;

environment = "production";

//development
var configVariables = {
  ENDPOINT:
    "https://55budmndirckhmm6drniq24jlm.appsync-api.ap-south-1.amazonaws.com/graphql",
  AUTHENTICATION_TYPE: "AMAZON_COGNITO_USER_POOLS",
  API_KEY: "rx5tj3agujdrfjrgt25z6byyou",
  REGION: "ap-south-1",
  accessKeyId: "AKIAVKH6JEUBXEXOCBWY",
  secretAccessKey: "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",
  BUCKET: "pms-vtwo-dev",
  COGNITO_USERPOOL_ID: "ap-south-1_4vKgGugmh",
  COGNITO_USERPOOL_WEBCLIENT_ID: "7bktrqg0gik7lbt962givobjdq",
  API_ENDPOINT:
    "https://cw5f8t8a3i.execute-api.ap-south-1.amazonaws.com/dev/api",
  FLIPBOOK_API_ENDPOINT:
    "https://feqituyulh.execute-api.ap-south-1.amazonaws.com/dev/api",
  amplifyUrl: "https://new-prod.d55bwwnoe2fy7.amplifyapp.com",
};

//development
if (environment == "development") {
  configVariables = {
    ENDPOINT:
      "https://55budmndirckhmm6drniq24jlm.appsync-api.ap-south-1.amazonaws.com/graphql",
    AUTHENTICATION_TYPE: "AMAZON_COGNITO_USER_POOLS",
    API_KEY: "rx5tj3agujdrfjrgt25z6byyou",
    REGION: "ap-south-1",
    accessKeyId: "AKIAVKH6JEUBXEXOCBWY",
    secretAccessKey: "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",
    BUCKET: "pms-vtwo-dev",
    COGNITO_USERPOOL_ID: "ap-south-1_4vKgGugmh",
    COGNITO_USERPOOL_WEBCLIENT_ID: "7bktrqg0gik7lbt962givobjdq",
    API_ENDPOINT:
      "https://cw5f8t8a3i.execute-api.ap-south-1.amazonaws.com/dev/api",
    FLIPBOOK_API_ENDPOINT:
      "https://feqituyulh.execute-api.ap-south-1.amazonaws.com/dev/api",
    amplifyUrl: "https://new-prod.d55bwwnoe2fy7.amplifyapp.com",
  };
}

//testing
if (environment == "testing") {
  configVariables = {
    ENDPOINT:
      "https://gwefwskfpneujnocy3hstwxq2y.appsync-api.ap-south-1.amazonaws.com/graphql",
    AUTHENTICATION_TYPE: "AMAZON_COGNITO_USER_POOLS",
    API_KEY: "rx5tj3agujdrfjrgt25z6byyou",
    REGION: "ap-south-1",
    accessKeyId: "AKIAVKH6JEUBXEXOCBWY",
    secretAccessKey: "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",
    BUCKET: "pms-vtwo-qa",
    COGNITO_USERPOOL_ID: "ap-south-1_wEucfuJc3",
    COGNITO_USERPOOL_WEBCLIENT_ID: "537666g5h485urgnn9i7rao45e",
    // API_ENDPOINT:'https://o1xk7s8z3f.execute-api.ap-south-1.amazonaws.com/QA/api'
    API_ENDPOINT:
      "https://am5spygrfb.execute-api.ap-south-1.amazonaws.com/QA/api",
    FLIPBOOK_API_ENDPOINT:
      "https://yhutn9sgch.execute-api.ap-south-1.amazonaws.com/QA/api",
    amplifyUrl: "https://new-prod.d55bwwnoe2fy7.amplifyapp.com",
  };
}

//production
if (environment == "production") {
  configVariables = {
    ENDPOINT:
      "https://2gjitrfjnndofdenehgovkwl5a.appsync-api.ap-south-1.amazonaws.com/graphql",
    AUTHENTICATION_TYPE: "AMAZON_COGNITO_USER_POOLS",
    API_KEY: "mpr4e6nlkzaalcc4hi4tswsnom",
    REGION: "ap-south-1",
    // accessKeyId: 'AKIAVKH6JEUBXEXOCBWY',
    accessKeyId: "AKIAVKH6JEUB645JNDHN",
    // secretAccessKey: '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',
    secretAccessKey: "2HzBHZb3ywzeCkzVlPzAc/URRshyotS+JGfhGD0v",
    BUCKET: "pms-vtwo-prod",
    COGNITO_USERPOOL_ID: "ap-south-1_4SEdjsyKE",
    COGNITO_USERPOOL_WEBCLIENT_ID: "2qjh8u4p1pc8amhgcke5dooglk",
    API_ENDPOINT:
      "https://j7oyaqlt83.execute-api.ap-south-1.amazonaws.com/prod/api",
    FLIPBOOK_API_ENDPOINT:
      "https://a3ybuinmdc.execute-api.ap-south-1.amazonaws.com/prod/api",
    amplifyUrl: "https://new-prod.d55bwwnoe2fy7.amplifyapp.com",
  };
}

export { configVariables };
